import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import React from "react";
import { AppMisc } from "../../../../misc/appMisc";
import { NO_RECORDS_FOUND } from "../../../../utils/constants";

export default function MunicipalitiesList(props) {

  function editRow(id) {
    props.editRow(id);
  }

  return (
    <TableContainer>
      <Table classes={{ root: "table-bordered" }} size="small" aria-label="जन-आवाज प्रणाली - सबै नगरपालिकाहरु">
        <TableHead classes={{ root: "align-center" }}>
          <TableRow>
            <TableCell>प्रदेश</TableCell>
            <TableCell>जिल्ला</TableCell>
            <TableCell>पालिकाको नाम</TableCell>
            <TableCell>ठेगाना</TableCell>
            <TableCell>फोन नम्बर</TableCell>
            <TableCell>ईमेल</TableCell>
            <TableCell>वेबसाइट</TableCell>
            {
              props.tableData.length !== 0 && <TableCell>सम्पादन</TableCell>
            }
          </TableRow>
        </TableHead>
        <TableBody classes={{ root: "align-center" }}>
          {props.tableData.length === 0 ?
            (
              <TableRow>
                <TableCell colSpan={7} size="medium">{NO_RECORDS_FOUND}</TableCell>
              </TableRow>
            ) : (
              props.tableData.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{AppMisc.getProvinceName(row.province)}</TableCell>
                  <TableCell>{AppMisc.getDistrictName(row.district)}</TableCell>
                  <TableCell><a href={`municipality-home?id=${row.id}`}>{row.palikaName ? AppMisc.getMunicipalityName(row.palikaName) : "-"}</a></TableCell>
                  <TableCell>{row.address || "-"}</TableCell>
                  <TableCell>{row.phoneNumber || "-"}</TableCell>
                  <TableCell>{row.email || "-"}</TableCell>
                  <TableCell>{row.website ? <a href={row.website} rel="noopener noreferrer" target="_blank">{row.website}</a> : "-"}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => editRow(row.id)}>
                      <Edit fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )
          }
        </TableBody>
      </Table>
    </TableContainer>
  );
}
